/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_About_TitleInputs */

const en_pc_dl_about_title = /** @type {(inputs: Pc_Dl_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About this PdfCraft download`)
};

const zh_pc_dl_about_title = /** @type {(inputs: Pc_Dl_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 PdfCraft 下载`)
};

/**
* | output |
* | --- |
* | "About this PdfCraft download" |
*
* @param {Pc_Dl_About_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_about_title = /** @type {((inputs?: Pc_Dl_About_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_About_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_about_title(inputs)
	return zh_pc_dl_about_title(inputs)
});
export { pc_dl_about_title as "pc.dl.about_title" }